export const SelectProject = () => {
  return {
    title: 'Új projekt kiválasztása?',
    icon: 'warning',
    showCancelButton: true,
    reverseButtons: true,
    allowOutsideClick: false,
    confirmButtonText: 'Igen',
    cancelButtonText: 'Nem',
    customClass: {
      actions: 'popup-buttons',
      confirmButton: 'btn btn-primary mat-raised-button mat-button-base',
      cancelButton:
        'btn btn-primary btn-link mat-raised-button mat-button-base',
    },
    buttonsStyling: false,
    preConfirm: (result) => {
      if (result) {
        return {
          message: 'yes',
        };
      }
    },
  };
};
